import { render, staticRenderFns } from "./AboutFurminator.vue?vue&type=template&id=0c4b888a&scoped=true"
import script from "./AboutFurminator.vue?vue&type=script&lang=js"
export * from "./AboutFurminator.vue?vue&type=script&lang=js"
import style0 from "./AboutFurminator.vue?vue&type=style&index=0&id=0c4b888a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4b888a",
  null
  
)

export default component.exports